<template>
<div>
  <v-card
    class="menuBar"
    flat
    tile>
    <v-toolbar color="primary" dark dense height="60">
      <v-btn v-if="hasBackButton" @click="goBack()" icon color="primary" type="icon" style="float: left; margin-right:20px;"><v-icon color="white">mdi-undo</v-icon></v-btn>
      <v-btn v-if="!hasBackButton" icon color="primary" type="icon" style="float: left; margin-right:20px;" disabled></v-btn>
      <v-img
        :src="myImage"
        style="border-radius:10px;"
        aspect-ratio="1"
        max-width="50"
        max-height="50">
      </v-img>
      <v-toolbar-title class="barTitle">Firmatya</v-toolbar-title>
      <v-spacer></v-spacer>
      <span v-if='hasMenu'>
        <span>{{username}}</span>
        <v-menu offset-y>
          <template v-slot:activator="{ on }">
            <v-btn icon v-on="on">
              <v-icon>mdi-account-circle</v-icon>
            </v-btn>
          </template>
          <v-list>
            <v-list-item @click="logout">
              <v-list-item-title>Cerrar Sesión</v-list-item-title>
            </v-list-item>
            <v-list-item @click="changeDialog = true">
              <v-list-item-title>Cambiar Contraseña</v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
      </span>
    </v-toolbar>
  </v-card>
  <v-dialog
      v-model="changeDialog"
      width="500"
    >
      <v-card>
        <v-card-title class="headline grey lighten-2" primary-title>
          Cambiar contraseña de {{username}}
          <v-spacer></v-spacer>
          <v-btn
            icon
            @click='switchAll($event)'
            :title='(!show.all ? "Mostrar" : "Ocultar") + " todos"'
          ><v-icon>{{ show.all ? 'mdi-eye' : 'mdi-eye-off' }}</v-icon></v-btn>
        </v-card-title>
        <v-card-text>
          <v-row><v-col></v-col></v-row>
          <v-row>
            <v-spacer></v-spacer>
            <v-col class="d-flex" cols="12" sm="10">
              <v-text-field
              v-model='password.oldPassword'
              label="Contraseña anterior"
              outlined
              :append-icon="show.old ? 'mdi-eye' : 'mdi-eye-off'"
              :type="show.old ? 'text' : 'password'"
              @click:append="show.old = !show.old"
              ></v-text-field>
            </v-col>
            <v-spacer></v-spacer>
          </v-row>
          <v-row>
            <v-spacer></v-spacer>
            <v-col class="d-flex" cols="12" sm="10">
              <v-text-field
              v-model='password.newPassword'
              label="Nueva Contraseña"
              outlined
              :append-icon="show.new ? 'mdi-eye' : 'mdi-eye-off'"
              :type="show.new ? 'text' : 'password'"
              @click:append="show.new = !show.new"
              ></v-text-field>
            </v-col>
            <v-spacer></v-spacer>
          </v-row>
          <v-row>
            <v-spacer></v-spacer>
            <v-col class="d-flex" cols="12" sm="10">
              <v-text-field
              v-model='password.repeatPassword'
              label="Repetir Nueva Contraseña"
              outlined
              :append-icon="show.repeat ? 'mdi-eye' : 'mdi-eye-off'"
              :type="show.repeat ? 'text' : 'password'"
              @click:append="show.repeat = !show.repeat"
              ></v-text-field>
            </v-col>
            <v-spacer></v-spacer>
          </v-row>
        </v-card-text>
        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click="changePassword()">Cambiar</v-btn>
          <v-btn color="error" text @click="changeDialog = false">Cancelar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
</div>
</template>

<script>
import { incompleteQuery } from '@/utils/checkQuery.js';
import { toasterErrorMessage } from '@/utils/responseCatchMessages.js';
import { mapGetters } from 'vuex';
export default {
  name: 'menuBar',
  data: () => ({
    myImage: require('@/assets/icon.png'),
    noBackButtonNames: [
      'Menu',
      'Login',
      'Confirmar',
    ],
    noMenuNames: [
      'Login',
      'Registro',
      'Confirmar',
      'CambiarPassword'
    ],
    defaultName: 'Menu',
    changeDialog: false,
    password: {
      oldPassword: '',
      newPassword: '',
      repeatPassword: '',
    },
    show: {
      old: false,
      new: false,
      repeat: false,
      all: false,
    },
  }),
  computed: {
    request() {
      let request = JSON.parse(JSON.stringify(this.password));
      request.user = this.username;
      return request;
    },
    hasBackButton() {
      const currentName = this.$route.name;
      if (this.noBackButtonNames.indexOf(currentName) > -1) return false;
      if (this.hasFirmarQuery) return false;
      return true;
    },
    hasMenu() {
      const currentName = this.$route.name;
      if (this.noMenuNames.indexOf(currentName) > -1) return false;
      if (this.hasFirmarQuery) return false;
      return true;
    },
    hasFirmarQuery() {
      const currentName = this.$route.name;
      const query = this.$route.query;
      const requiredParams = ['c', 'd'];
      if (currentName === 'Firmar' && !incompleteQuery(query, requiredParams)) return true;
      return false;
    },
    username() {
      const user = this.getUser();
      if (user.username !== undefined && !this.hasFirmarQuery) return user.username;
      return '';
    },
  },
  methods:{
    ...mapGetters(['getUser']),
    goBack() {
      const currentName = this.$route.name;
      let name = this.defaultName;
      if (currentName === 'Firmar') name = 'Contrato';
      if (currentName === 'Registro') name = 'Login';
      this.$router.push({ name });
    },
    logout() {
      this.$store.dispatch('logout');
    },
    validatePassword() {
      for (const name in this.password) {
        if (this.password[name].length === 0) {
          this.$toast.error('Campos faltantes');
          return false;
        }
      }
      if (this.password.newPassword !== this.password.repeatPassword) {
        this.$toast.error("La confirmación de contraseña no coincide");
        return false;
      } 
      return true;
    },
    async changePassword(){
      if (!this.validatePassword()) return;
      try {
        const request = this.request;
        const result = await this.$store.dispatch('changePassword', {request}).then(res => {
          this.$toast.success("La contraseña fue modificada");
          this.changeDialog = false;
        });
      } catch (e) {
        console.error("changePassword Error: %o", e);
        toasterErrorMessage(this.$toast.error, e, "No se pudo cambiar la contraseña");
      }
    },
    resetParams(){
      this.password = {
        oldPassword: '',
        newPassword: '',
        repeatPassword: '',
      }
      this.switchAll({}, false);
    },
    switchAll(event, toValue = null) {
      const newValue = (toValue === null ? !this.show.all : toValue)
      for (const name in this.show) this.show[name] = newValue;
    },
  },
  watch: {
    changeDialog() {
      if (!this.changeDialog) {
        this.resetParams();
      }
    },
  }
};
</script>

<style scoped>
.menuBar {
  z-index: 10;
}
.barTitle {
  padding-left: 20px;
  font-size: 18pt;
  font-family: Arial, sans-serif;
  font-weight: 900;
}
</style>
